var DL_SKU_SUFFIX = '_DL';
var DL_START_INDEX = 1;
var DL_END_INDEX = 9;

/**
 * Returns original product id
 * @param {string} productId Product Id
 * @returns {string} Canonical product Id
 */
function getCanonicalProductId(productId) {
    var result = new RegExp(
        '^(.*)' + DL_SKU_SUFFIX + '[' + DL_START_INDEX + '-' + DL_END_INDEX + ']$'
    ).exec(productId);
    return result ? result[1] : productId;
}

/**
 * Check if product is a Double Look product
 * @param {string} productId Product Id
 * @returns {boolean} is a Double Look product
 */
function isDoubleLookProduct(productId) {
    return productId !== getCanonicalProductId(productId);
}

module.exports = {
    isDoubleLookProduct: isDoubleLookProduct,
    getCanonicalProductId: getCanonicalProductId
};
